import React, { useEffect, useState } from "react";
import { Modal, Row, Col, Select, Input, InputNumber, Button, Typography, message } from "antd";
import { SaveOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { updateShipping } from "../shippingThunk";

const { Text } = Typography;

const emptyForm = {
    shipping_type: "sales",
    sscc_code: "",
    sender_gln: "",
    receiver_gln: "",
    sender_gcp_length: 10,
    receiver_gcp_length: 10,
};

const ShippingEditModal = ({ open, record, onClose, onUpdated }) => {
    const dispatch = useDispatch();
    const [form, setForm] = useState(emptyForm);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        if (open && record) {
            setForm({
                shipping_type: record.shipping_type,
                sscc_code: record.sscc_code,
                sender_gln: record.sender_gln,
                receiver_gln: record.receiver_gln,
                sender_gcp_length: record.sender_gcp_length,
                receiver_gcp_length: record.receiver_gcp_length,
            });
        }
    }, [open, record]);

    const setField = (field) => (value) =>
        setForm((prev) => ({ ...prev, [field]: value?.target ? value.target.value : value }));

    const handleSave = async () => {
        if (!form.sscc_code || !form.sscc_code.trim()) {
            message.error("SSCC Code is required");
            return;
        }
        if (!form.sender_gln || !form.sender_gln.trim()) {
            message.error("Sender GLN is required");
            return;
        }
        if (!form.receiver_gln || !form.receiver_gln.trim()) {
            message.error("Receiver GLN is required");
            return;
        }

        setSaving(true);
        try {
            const result = await dispatch(
                updateShipping({ id: record.id, ...form })
            ).unwrap();

            message.success(result.message || "Shipping record updated successfully");
            onUpdated?.();
            onClose();
        } catch (err) {
            message.error(err || "Failed to update shipping record");
        } finally {
            setSaving(false);
        }
    };

    return (
        <Modal
            title="Edit Shipping"
            open={open}
            onCancel={onClose}
            footer={null}
            destroyOnClose
        >
            <Row gutter={[16, 16]}>
                <Col span={24}>
                    <Text strong>Shipping Type</Text>
                    <Select
                        style={{ width: "100%", marginTop: 5 }}
                        value={form.shipping_type}
                        onChange={setField("shipping_type")}
                        options={[
                            { label: "Sales", value: "sales" },
                            { label: "Purchase Return", value: "purchase_return" },
                        ]}
                    />
                </Col>

                <Col span={24}>
                    <Text strong>SSCC Code</Text>
                    <Input
                        style={{ marginTop: 5 }}
                        value={form.sscc_code}
                        onChange={setField("sscc_code")}
                    />
                </Col>

                <Col xs={24} md={12}>
                    <Text strong>Sender GLN</Text>
                    <Input
                        style={{ marginTop: 5 }}
                        value={form.sender_gln}
                        onChange={setField("sender_gln")}
                    />
                </Col>

                <Col xs={24} md={12}>
                    <Text strong>Sender Prefix Length</Text>
                    <InputNumber
                        min={6}
                        max={12}
                        precision={0}
                        style={{ width: "100%", marginTop: 5 }}
                        value={form.sender_gcp_length}
                        onChange={setField("sender_gcp_length")}
                    />
                </Col>

                <Col xs={24} md={12}>
                    <Text strong>Destination GLN</Text>
                    <Input
                        style={{ marginTop: 5 }}
                        value={form.receiver_gln}
                        onChange={setField("receiver_gln")}
                    />
                </Col>

                <Col xs={24} md={12}>
                    <Text strong>Destination Prefix Length</Text>
                    <InputNumber
                        min={6}
                        max={12}
                        precision={0}
                        style={{ width: "100%", marginTop: 5 }}
                        value={form.receiver_gcp_length}
                        onChange={setField("receiver_gcp_length")}
                    />
                </Col>

                <Col span={24}>
                    <Button
                        type="primary"
                        icon={<SaveOutlined />}
                        loading={saving}
                        onClick={handleSave}
                        block
                    >
                        Save Changes
                    </Button>
                </Col>
            </Row>
        </Modal>
    );
};

export default ShippingEditModal;
